import {Component, Input} from '@angular/core';
import {LoaderService} from "@services";

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponent {
  @Input() isAdmin: boolean = false;

  constructor(public loader: LoaderService) {
  }
}
